import $ from 'jquery';

export class TimeList {
    constructor(element) {
        this.baseRadioTimeTemplate = element;
    }
    fillElement(data) {
        const formGroup = $(this.baseRadioTimeTemplate.content.cloneNode(true));
        const inputEl = formGroup.find('input');

        formGroup.find('.radio-text').text(data.time);
        inputEl.val(JSON.stringify({ id: data.id, time: data.time }));
        inputEl.attr('name', 'time');
        inputEl.attr('disabled', !data.free);

        return formGroup;
    }
}
